import { Dropdown, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { CirclePicker } from "react-color";

function ColorPicker(props) {
  const [hexColor, setHexColor] = useState("");

  useEffect(() => {
    setHexColor(props.color || "#03a9f4");
  }, [props.color]);

  function changeColor(color) {
    setHexColor(color);
    props.onChange(color);
  }

  const menu = (
    <Menu>
      <div className="p-3">
        <CirclePicker
          color={props.color || ""}
          onChangeComplete={(color) => {
            changeColor(color.hex);
          }}
        />
      </div>
    </Menu>
  );

  return (
    <>
      <Dropdown placement="bottomRight" overlay={menu} trigger={["click"]}>
        <div
          style={{ borderColor: "#d9d9d9" }}
          className="border p-1 rounded cursor-pointer h-full"
        >
          <div style={{ backgroundColor: hexColor }} className="h-full"></div>
        </div>
      </Dropdown>
    </>
  );
}

export default ColorPicker;
